import { IsNotEmpty, IsOptional, IsString } from 'class-validator';

export const EMPTY_NAME_MESSAGE = 'Please enter a name for this node';
export const EMPTY_NEXT_ID_MESSAGE = 'Please select the next node the customer will go to';
export const EMPTY_ERROR_ID_MESSAGE = 'Please select the error node if an error occurs';

export default abstract class BaseIvrNode {
  id: string;

  @IsString()
  @IsNotEmpty({ message: EMPTY_NAME_MESSAGE })
  name: string;

  @IsString()
  @IsOptional()
  description: string;
}
